import FormControl from "@mui/material/FormControl/FormControl";
import FormGroup from "@mui/material/FormGroup";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import AppState from "../../AppState";
import { IFilterForm } from "../../AppState/overagesFilterFormActions";
import { saveExceptionSearchFilterForm } from "../../AppState/exceptionSearchFilterFromAction";

const SearchWithBarcode: React.FC = () => {
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const filterForm: IFilterForm = useSelector(
    (state: AppState) => state.exceptionSearchFilterForm
  );

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const handleSearch = () => {
    const searchStr = searchValue.trim();
    if (!searchStr) return;
    const filterFormParam: IFilterForm = { ...filterForm, search: searchStr };
    dispatch(saveExceptionSearchFilterForm(filterFormParam));
    navigate(`/exceptions/search`);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <FormGroup className="flex-update">
      <FormControl className="search-input">
        <TextField
          autoComplete="off"
          placeholder="Search with exception details"
          id="outlined-start-adornment"
          variant="outlined"
          size="medium"
          fullWidth
          value={searchValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          InputProps={{
            inputProps: {
              maxLength: 50,
            },
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </FormControl>
      <FormGroup>
        <Button
          variant="contained"
          className="search-btn search-effect"
          disableElevation
          onClick={handleSearch}
        >
          Search
        </Button>
      </FormGroup>
    </FormGroup>
  );
};

export default SearchWithBarcode;
